import { Grid } from "@mui/material";
import ModalGeneric from "../Generics/ModalGeneric";
import Titulo3 from "../Generics/Titulo3";
import Info from "../Generics/Info";

import dayjs from "dayjs";
import { DadosMovimentacaoManutencao } from "../../model/entities/ProgramaManutencao";

type Props = {
  open: boolean;
  onClose: () => void;
  dadosMovimentacao: DadosMovimentacaoManutencao;
};

const ModalInfoMovimentacaoManutencao: React.FC<Props> = (props) => {
  const { open, onClose, dadosMovimentacao } = props;

  return (
    <ModalGeneric open={open} onClose={onClose}>
      <Grid container spacing={2}>
        <Grid item md={12} style={{ textAlign: "center" }}>
          <Titulo3>Movimentação de Veículo em Manutenção</Titulo3>
        </Grid>

        <Grid item md={12} xs={12}>
          <Info
            label={"Placa do Veículo"}
            children={dadosMovimentacao.placaVeiculo}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"Tipo da Movimentação"}
            children={dadosMovimentacao.tipoMovimentacaoManutencao}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"Data e hora da movimentação"}
            children={dayjs(dadosMovimentacao.dataHoraSolicitacao).format(
              "DD/MM/YYYY - HH:mm"
            )}
          />
        </Grid>

        <Grid item md={12} xs={12}>
          <Info label={"Fornecedor"} children={dadosMovimentacao.fornecedor} />
        </Grid>

        {dadosMovimentacao.tipoMovimentacaoManutencao !== "RETORNO" && (
          <Grid item md={12} xs={12}>
            <Info
              label={"Previsão de conclusão"}
              children={dadosMovimentacao.previsaoConclusao}
            />
          </Grid>
        )}

        <Grid item md={12} xs={12}>
          <Info label={"Observação"} children={dadosMovimentacao.observacao} />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"Registrado por"}
            children={dadosMovimentacao.nomeUsuario}
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <Info
            label={"Contato responsável pelo registro"}
            children={dadosMovimentacao.contatoUsuario.replace(
              "whatsapp:+",
              ""
            )}
          />
        </Grid>

        <Grid item md={12} xs={12}>
          <Info
            label={"E-mail enviado para"}
            children={dadosMovimentacao.emailDestinatario}
          />
        </Grid>
      </Grid>
    </ModalGeneric>
  );
};

export default ModalInfoMovimentacaoManutencao;
